import AxiosApi from "axios";
import {
  ADD_RECORD_FAIL,
  ADD_RECORD_REQUEST,
  ADD_RECORD_SUCCESS,
  RECORD_MINE_LIST_REQUEST,
  RECORD_MINE_LIST_SUCCESS,
  RECORD_MINE_LIST_FAIL,
  RECORD_SUMMARY_REQUEST,
  RECORD_SUMMARY_SUCCESS,
  RECORD_SUMMARY_FAIL,
  RECORD_LIST_REQUEST,
  RECORD_LIST_SUCCESS,
  RECORD_LIST_FAIL,
  ADD_YEARLYREPORT_REQUEST,
  ADD_YEARLYREPORT_SUCCESS,
  ADD_YEARLYREPORT_FAIL,
  LIST_YEARLYREPORT_REQUEST,
  LIST_YEARLYREPORT_SUCCESS,
  LIST_YEARLYREPORT_FAIL,
  SEARCH_RECORD_REQUEST,
  SEARCH_RECORD_SUCCESS,
  SEARCH_RECORD_FAIL,
  RECORD_CATEGORY_LIST_REQUEST,
  RECORD_CATEGORY_LIST_SUCCESS,
  RECORD_CATEGORY_LIST_FAIL,
  RECORD_DELETE_REQUEST,
  RECORD_DELETE_SUCCESS,
  RECORD_DELETE_FAIL,
  RECORD_DETAILS_REQUEST,
  RECORD_DETAILS_SUCCESS,
  RECORD_DETAILS_FAIL,
  RECORD_UPDATE_REQUEST,
  RECORD_UPDATE_SUCCESS,
  RECORD_UPDATE_FAIL,
  ADD_CATEGORY_FAIL,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  CATEGORY_DELETE_REQUEST,
  CATEGORY_DELETE_SUCCESS,
  CATEGORY_DELETE_FAIL,
  ADD_TAXRATE_REQUEST,
  ADD_TAXRATE_SUCCESS,
  ADD_TAXRATE_FAIL,
  RECORD_TAXRATE_LIST_REQUEST,
  RECORD_TAXRATE_LIST_SUCCESS,
  RECORD_TAXRATE_LIST_FAIL,
  TAXRATE_DELETE_REQUEST,
  TAXRATE_DELETE_SUCCESS,
  TAXRATE_DELETE_FAIL,
  TAXRATE_UPDATE_REQUEST,
  TAXRATE_UPDATE_SUCCESS,
  TAXRATE_UPDATE_FAIL,
  ONE_TAXRATE_LIST_REQUEST,
  ONE_TAXRATE_LIST_SUCCESS,
  ONE_TAXRATE_LIST_FAIL,
} from "../constants/financeConstants";

const Axios = AxiosApi.create({
  baseURL: process.env.REACT_APP_VIVOLEO_FINMAN_API,
});

export const addfinancerec =
  (
    description,
    invoiceamount,
    currency,
    category,
    inoivcefile,
    paymentmethod,
    paymentdate,
    payby,
    payto,
    otherinfo,
    paydate
  ) =>
  async (dispatch) => {
    dispatch({
      type: ADD_RECORD_REQUEST,
      payload: {
        description,
        invoiceamount,
        currency,
        category,
        inoivcefile,
        paymentmethod,
        paymentdate,
        payby,
        payto,
        otherinfo,
        paydate,
      },
    });
    try {
      const { data } = await Axios.post("/api/finance/addfinancerec", {
        description,
        invoiceamount,
        currency,
        category,
        inoivcefile,
        paymentmethod,
        paymentdate,
        payby,
        payto,
        otherinfo,
        paydate,
      });
      dispatch({ type: ADD_RECORD_SUCCESS, payload: data });
      localStorage.setItem("addFinanceRec", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: ADD_RECORD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listRecordMine = () => async (dispatch, getState) => {
  dispatch({ type: RECORD_MINE_LIST_REQUEST });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = await Axios.get("/api/finance/listrecord", {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    dispatch({ type: RECORD_MINE_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: RECORD_MINE_LIST_FAIL,
      payload: message,
    });
  }
};

export const summaryRecord = () => async (dispatch, getState) => {
  dispatch({ type: RECORD_SUMMARY_REQUEST });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = await Axios.get("/api/finance/summary", {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({ type: RECORD_SUMMARY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RECORD_SUMMARY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
/*
  export const listRecords = ({
    pageNumber = '',
    seller = '',
    name = '',
    category = '',
    order = '',
    min = 0,
    max = 0,
    rating = 0,
  }) => async (dispatch) => {
    dispatch({
      type: RECORD_LIST_REQUEST,
    });
    try {
      const { data } = await Axios.get(
        `/api/records?pageNumber=${pageNumber}&seller=${seller}&name=${name}&category=${category}&min=${min}&max=${max}&rating=${rating}&order=${order}`
      );
      dispatch({ type: RECORD_LIST_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: RECORD_LIST_FAIL, payload: error.message });
    }
  };
  */
export const searchRecords =
  ({ category = "", fromdate = "01/01/2021", todate = "31/12/2021" }) =>
  async (dispatch) => {
    dispatch({
      type: SEARCH_RECORD_REQUEST,
    });
    try {
      const { data } = await Axios.get(
        `/api/finance/searchrecord?category=${category}`
      );
      dispatch({ type: SEARCH_RECORD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: SEARCH_RECORD_FAIL, payload: error.message });
    }
  };

export const updateYearlyReport =
  (
    description,
    year,
    category,
    amount,
    currency,
    fromdate,
    todate,
    otherinfo
  ) =>
  async (dispatch) => {
    dispatch({
      type: LIST_YEARLYREPORT_REQUEST,
      payload: {
        description,
        year,
        category,
        amount,
        currency,
        fromdate,
        todate,
        otherinfo,
      },
    });
    try {
      const { data } = await Axios.post("/api/finance/listyearlyreport", {
        description,
        year,
        category,
        amount,
        currency,
        fromdate,
        todate,
        otherinfo,
      });
      dispatch({ type: LIST_YEARLYREPORT_SUCCESS, payload: data });
      localStorage.setItem("existedYearlyReport", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: LIST_YEARLYREPORT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listYearlyReport = () => async (dispatch, getState) => {
  dispatch({ type: LIST_YEARLYREPORT_REQUEST });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = await Axios.get("/api/finance/listyearlyreport", {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    dispatch({ type: LIST_YEARLYREPORT_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: LIST_YEARLYREPORT_FAIL, payload: message });
  }
};

export const listRecordCategories = () => async (dispatch) => {
  dispatch({
    type: RECORD_CATEGORY_LIST_REQUEST,
  });
  try {
    const { data } = await Axios.get(`/api/finance/categories`);
    dispatch({ type: RECORD_CATEGORY_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: RECORD_CATEGORY_LIST_FAIL, payload: message });
  }
};
/*
export const listCategories = () => async (dispatch) => {
  dispatch({
    type: RECORD_CATEGORY_LIST_REQUEST,
  });
  try {
    const { data } = await Axios.get(`/api/finance/categories`);
    dispatch({ type: RECORD_CATEGORY_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: RECORD_CATEGORY_LIST_FAIL, payload: message });
  }
};
*/
export const deleteRecord = (recordId) => async (dispatch, getState) => {
  dispatch({ type: RECORD_DELETE_REQUEST, payload: recordId });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = Axios.delete(`/api/finance/${recordId}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({ type: RECORD_DELETE_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: RECORD_DELETE_FAIL, payload: message });
  }
};

export const detailsRecord = (recordId) => async (dispatch) => {
  dispatch({ type: RECORD_DETAILS_REQUEST, payload: recordId });
  try {
    const { data } = await Axios.get(`/api/finance/records/${recordId}`);
    dispatch({ type: RECORD_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RECORD_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateRecord = (record) => async (dispatch, getState) => {
  dispatch({ type: RECORD_UPDATE_REQUEST, payload: record });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = await Axios.put(
      `/api/finance/records/${record._id}`,
      record,
      {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      }
    );
    dispatch({ type: RECORD_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: RECORD_UPDATE_FAIL, error: message });
  }
};

export const addcategoryrec = (category, otherinfo) => async (dispatch) => {
  dispatch({
    type: ADD_CATEGORY_REQUEST,
    payload: {
      category,
      otherinfo,
    },
  });
  try {
    const { data } = await Axios.post("/api/finance/addcategoryrec", {
      category,
      otherinfo,
    });
    dispatch({ type: ADD_CATEGORY_SUCCESS, payload: data });
    localStorage.setItem("addCategoryRec", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: ADD_CATEGORY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteCategory = (categoryId) => async (dispatch, getState) => {
  dispatch({ type: CATEGORY_DELETE_REQUEST, payload: categoryId });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = Axios.delete(`/api/finance/category/${categoryId}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({ type: CATEGORY_DELETE_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: CATEGORY_DELETE_FAIL, payload: message });
  }
};

export const addTaxrateRec =
  (taxrate, description, otherinfo, category) => async (dispatch) => {
    dispatch({
      type: ADD_TAXRATE_REQUEST,
      payload: {
        taxrate,
        description,
        otherinfo,
        category,
      },
    });
    try {
      const { data } = await Axios.post("/api/finance/addtaxraterec", {
        taxrate,
        description,
        otherinfo,
        category,
      });
      dispatch({ type: ADD_TAXRATE_SUCCESS, payload: data });
      localStorage.setItem("addedTaxrateRec", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: ADD_TAXRATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listRecordTaxrates = () => async (dispatch) => {
  dispatch({
    type: RECORD_TAXRATE_LIST_REQUEST,
  });
  try {
    const { data } = await Axios.get(`/api/finance/taxrates`);
    dispatch({ type: RECORD_TAXRATE_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: RECORD_TAXRATE_LIST_FAIL, payload: message });
  }
};

export const listOneTaxrate = (taxrate_id) => async (dispatch) => {
  dispatch({
    type: ONE_TAXRATE_LIST_REQUEST,
    payload: taxrate_id,
  });
  try {
    const { data } = await Axios.get(`/api/finance/taxrate/list/${taxrate_id}`);
    dispatch({ type: ONE_TAXRATE_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: ONE_TAXRATE_LIST_FAIL, payload: message });
  }
};

export const deleteTaxrate = (taxrateId) => async (dispatch, getState) => {
  dispatch({ type: TAXRATE_DELETE_REQUEST, payload: taxrateId });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = Axios.delete(`/api/finance/taxrate/delete/${taxrateId}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({ type: TAXRATE_DELETE_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: TAXRATE_DELETE_FAIL, payload: message });
  }
};

export const updateTaxrate = (taxrate) => async (dispatch, getState) => {
  dispatch({ type: TAXRATE_UPDATE_REQUEST, payload: taxrate });
  const {
    userSignin: { userInfo },
  } = getState();
  try {
    const { data } = await Axios.put(
      `/api/finance/taxrate/update/${taxrate._id}`,
      taxrate,
      {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      }
    );
    dispatch({ type: TAXRATE_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: TAXRATE_UPDATE_FAIL, error: message });
  }
};
